import styled from 'styled-components';

export const MapContainer = styled.section`
	padding: 1rem;
	margin-bottom: 2rem;
`;

export const MapHolder = styled.div`
	background: var(--ion-color-step-300);
	aspect-ratio: 4/3;
	border-radius: 12px;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const MapButtonsHolder = styled.div`
	background: var(--ion-color-step-150);
	border-radius: 12px;
	padding: 1rem;
	display: flex;
	gap: 1rem;
	justify-content: space-evenly;
	align-items: center;
	ion-button {
		/* border: 2px solid var(--ion-color-step-450); */
		border-radius: 12px;
		svg {
			path {
				fill: #fff;
			}
			/* width: 15px; */
			height: 15px;
			&[data-name='Navigate-Icon'] {
				margin-right: 4px;
				margin-left: -4px;
			}
			&[data-name='VT-Icon'] {
				margin-right: 8px;
			}
			/* margin-left: -8px; */
		}
		width: 100%;
		font-size: 14px;
		margin: 0;
	}
`;
